import { inject as service } from '@ember/service';
import Route from 'cio/routes/base';
import TransactionalMessageSetupController from './controller';
import Transition from '@ember/routing/-private/transition';
import TransactionalMessageModel from 'cio/models/transactional-message';
import ConfirmChangesService from 'cio/services/confirm-changes';

export default class TransactionalMessageSetup extends Route {
  @service confirmChanges!: ConfirmChangesService;

  setupController(
    controller: TransactionalMessageSetupController,
    model: TransactionalMessageModel,
    transition: Transition,
  ) {
    super.setupController(controller, model, transition);

    this.confirmChanges.register(controller, this);
  }
}
